<template>
  <div class="help-page">
    <iframe
      class="help-page__manual"
      src="/html-tree/"
      title="Re:Column Help"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'Help',
}
</script>

<style scoped>
.help-page {
  width: 100%;
  height: calc(100vh - 49px);
  background-color: #ffffff;
}

.help-page__manual {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
